<template>
	<div class="incenters">
		<div style="">
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="DespatchExport"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<!-- <Commonbtn backgroundColor="#FFF" title="发票照片标注" fontSize="14px" @btnclick="invoicephoto" :src="require('@/assets/icon/phont.png')">
      </Commonbtn>
      <block v-for="(item , index) of fromdatalists" :key="index">
        <Commondropdownlist :inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color" :radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith" :placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype" :width="item.width" :min="item.min" :max="item.max">
        </Commondropdownlist>
      </block> -->
		</div>
		<!-- style="border: 1px solid blue;" -->
		<div class="TableWidth">
			<Commontable :loadingTable="loading" @onRowClick="onRowClick" colnum=7 :tableData="tableData"
				:headerData="headerData" height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>

		<DialogFrom width="648px" title="发票照片标注" :dialogVisible="dialogVisiblesinvoicephoto"
			@cancel="cancelinvoicephoto" @dialogOK="dialogOKinvoicephoto">
			<div style="color: #333333;font-size: 14px;">
				请填写发票照片校验状态标注：
			</div>
			<textarea style="border: 1px solid #E6E6E6;width: 608px;height: 180px;margin-top: 10px;"></textarea>
		</DialogFrom>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除该菜单吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledeactivate" @cancel="canceldeactivate"
			@dialogOK="dialogOKdeactivate" :src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要停用该菜单吗？</span>
		</Dialog>
	</div>
</template>
<script>
	import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
	import Commontable from '../../../../components/common-table.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import Pagination from '../../../../components/pagination.vue'
	import DialogFrom from '../../../../components/dialog-from.vue'
	import fromdata from '../fromData/add'
	import fromdataedit from '../fromData/edit'
	import Dialog from '../../../../components/dialog.vue'
	import {
		wmsDespatchInfo,
		wmsDespatchDetail,
		wmsDespatchDetailUnique,
		wmsDespatchExport,
		ASNVoucherType,
		InventoryClassList,
		wmsDespatchImport,
		CusType,
		CustomerList,
		HospitalList
	} from '@/api/home'
	export default {
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			DialogFrom,
			Commondropdownlist,
			Dialog
		},
		props: {
			tableData: {
				type: Array,
				default: Array
			},
			total: {
				type: Number,
				default: 0
			},
			loading: {
				type: Boolean,
				default: false
			}
		},
		data: function() {
			return {
				dialogVisibles: false,
				dialogVisiblesinvoicephoto: false,
				dialogVisibledel: false,
				dialogVisibledeactivate: false,
				headerData: [{
						prop: 'id',
						label: '序号',
						columnwidth: 50,

					},
					{
						prop: 'StatusName',
						label: '状态',
						columnwidth: 100
					},
					{
						prop: 'VouCode',
						label: '经销商出库单号',
						columnwidth: 150
					},
					{
						prop: 'InvClassName',
						label: '产品线',
						columnwidth: 80
					},
					{
						prop: 'DPDate',
						label: '出库日期',
						columnwidth: 100
					},
					{
						prop: 'ObjName',
						label: '付款方名称',
						columnwidth: 150
					},
					{
						prop: 'VoucherType',
						label: '单据类型',
						columnwidth: 100
					},
					{
						prop: 'WHName',
						label: '仓库名称',
						columnwidth: 150
					},
					{
						prop: 'Total',
						label: '出库金额',
						columnwidth: 80
					},
					{
						prop: 'Remark',
						label: '备注',
						columnwidth: 150
					},
					{
						prop: "DamageCode",
						label: "赔付入库单号",
						columnwidth: 160,
					},
					{
						prop: 'Creator',
						label: '创建人',
						columnwidth: 130
					},
					{
						prop: 'CreateTime',
						label: '创建时间',
						columnwidth: 130
					},
					{
						prop: 'Verifier',
						label: '审核人',
						columnwidth: 130
					},
					{
						prop: 'VerifyTime',
						label: '审核时间',
						columnwidth: 130
					}
				],
				fromdatalists: [{
					inputdata: '',
					fontSize: '14px',
					color: '#333333',
					placeholder: '颜色说明',
					types: '',
					inputtype: 'selects',
					width: '110px',
				}, ],
				qus: [],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
				},
			}
		},
		mounted() {
			this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
			this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
			let data = JSON.parse(localStorage.getItem("MenusData"))
			let NodeID = this.$route.query.NodeID
			data.Menus.map((item, index) => {
				if (item.NodeID == NodeID) {
					this.qus = item.Nodes[index].Nodes
				}
			})
			if (this.qus) {
				this.qus.map((item, index) => {
					if (item.NodeName == 'add') {
						this.qx.add = true
					} else if (item.NodeName == 'edit') {
						this.qx.update = true
					} else if (item.NodeName == 'delete') {
						this.qx.del = true
					} else if (item.NodeName == 'stopif') {
						this.qx.del = true
					} else if (item.NodeName == 'assignment') {
						this.qx.assignment = true
					} else if (item.NodeName == 'enabled') {
						this.qx.enabled = true
					} else if (item.NodeName == 'skip') {
						this.qx.skip = true
					} else if (item.NodeName == 'reset') {
						this.qx.reset = true
					}
				})
			}


			//console.log("qux", this.qus)
		},
		methods: {
			onRowClick(val) {
				this.rowboo = true
				this.dpmid = val.DPMID
				//console.log(val, "val")
				this.$emit("onRowClick", val)
			},
			DespatchExport() {
				this.$emit('DespatchExport')
			},
			commclick(type) {
				this[type] = true
			},
			canceldel() {

			},
			dialogOKdel() {

			},
			canceldeactivate() {

			},
			dialogOKdeactivate() {

			},
			adduser() {
				this.dialogVisibles = true
				//console.log(this.fromdataadd, '//console.log(this.fromdataadd)')
			},
			cancel() {
				this.dialogVisibles = false
			},
			dialogOK() {
				this.dialogVisibles = false
			},
			invoicephoto() {
				this.dialogVisiblesinvoicephoto = true
			},
			cancelinvoicephoto() {
				this.dialogVisiblesinvoicephoto = false
			},
			dialogOKinvoicephoto() {
				this.dialogVisiblesinvoicephoto = false
			},
			handleCurrentChange(pageindex) {
				this.$emit('handleCurrentChange', pageindex)
			},
			handleSizeChange(paegSzie) {
				this.$emit('handleSizeChange', paegSzie)
			},
		}
	}
</script>

<style lang="less" scoped>
	.incenters {
		height: 100%;

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 16px;
			padding-bottom: 16px;
		}

		// div {
		//   margin-left: 8px;
		//   margin-right: 8px;
		//   margin-top: 5px;
		//   margin-bottom: 5px;

		// }
		.from {
			width: 100%;
		}

		.signingroles {
			height: 500px;
			width: 100%;
			// display: flex;
			// justify-content: space-between;
			// align-items: center;
			// border: 1px solid red;

			.left {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
			}

			.right {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
				// pointer-events: none;
			}
		}
	}

	.right-s {
		position: absolute;
		z-index: 99;
		opacity: 0.5;
		right: 21px;
		width: 470px;
		height: 240px;
		background-color: #ffffff;
		cursor: no-drop;
	}

	.dwonleft {
		width: 170px;
		height: 48px;
		position: absolute;
		background-color: #ffffff;
		z-index: 99;
		right: 350px;
		top: 322px;
		text-align: center;
		line-height: 48px;
		color: #333333;
		box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
			0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
		border-radius: 2px;
		font-size: 14px;
		cursor: pointer;
	}

	.dwonleft:hover {
		background-color: #f0f0f0;
	}
</style>